import { applyPolyfills, defineCustomElements } from 'blip-ds/loader';

applyPolyfills().then(() => {
  defineCustomElements(window);
});
